<script setup>
    import { ref, computed, onMounted } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import insightsRecruitInfoService from "../../../../user/services/insights/insightsRecruitInfoService";
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import { useAlertStore } from '../../../../../stores/alertStore';
    const { $alert, $confirm } = useAlertStore();
    
    const route = useRoute();
    const router = useRouter();
    const loadingStore = usePageLoadingStore()

    onMounted(()=>{
        const { id } = route.params;
        if(!id) {
            router.push({name: 'CSRecruitInfoList'})
        } else {
          retrieveRecruitInfoDetail(id)
        }
    })

    const MAX_SIZE = 200;
    const recruitInfoDetail = ref({
        boardId: route.params.id || '',
        title: '',
        notifyYn: 'N',
        content: '',
        answer: '',
        attachList: [],
    });

    const retrieveRecruitInfoDetail = (id) => {
        loadingStore.loading = true;
        insightsRecruitInfoService.retrieveRecruitInfoDetail(id)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    recruitInfoDetail.value = result;
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    }

    const deleteRecruitInfo = async () => {
        const ok = await $confirm(["채용정보을 삭제할까요?", "삭제 시 사용자 사이트에 즉시 적용되며 되돌릴 수 없습니다."]);
        if(ok){
          _deleteRecruitInfo()
        }
    }

    function _deleteRecruitInfo() {
        loadingStore.loading = true;
        insightsRecruitInfoService.deleteRecruitInfo(recruitInfoDetail.value.boardId)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    goBack();
                } else {
                    $alert("삭제를 실패하였습니다.");
                }
            }).catch( (res) =>  {
            loadingStore.loading = false;
            console.log(res);
            $alert("삭제를 실패하였습니다.");
        });
    }

    const updateRecruitInfo = () => {
        router.push({name:'CSRecruitInfoUpdate', params:{id: recruitInfoDetail.value.boardId}})
    }

    const goBack = () => {
        router.push({name:'CSRecruitInfoList'})
    }

</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>채용정보</h3>
        </div>
        <div class="btn-wrap space-between">
            <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
            <div>
                <KSASecondaryButton text="수정" @click="updateRecruitInfo" />
                <KSASecondaryButton class="red_button" text="삭제" @click="deleteRecruitInfo" />
            </div>
        </div>
        <div class="board-detail">
            <div class="header">
                <div class="board-title">
                    <p v-if="recruitInfoDetail.notifyYn === 'Y'">{{ recruitInfoDetail.title }}📣<img v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName" src="/src/assets/images/icon-file.png" class="icon-file" /></p>
                    <p v-else>{{ recruitInfoDetail.title }}<img v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName" src="/src/assets/images/icon-file.png" class="icon-file" /></p>
                </div>
                <span>작성일<i>{{ $yyyymmddOrHHmm(recruitInfoDetail.createDate) }}</i></span>
                <span>작성자 <i>{{ recruitInfoDetail.createUserName }}<span v-if="recruitInfoDetail.createUserLoginId">({{ recruitInfoDetail.createUserLoginId}})</span></i></span>
                <span>조회수 <i>{{ $number(recruitInfoDetail.hitCount)}}</i></span>
            </div>
            <div class="body">
                <div class="text" v-html="recruitInfoDetail.content"></div>
            </div>
            <div class="control">
                <dl class="download" v-if="recruitInfoDetail.attachList.length > 0 && recruitInfoDetail.attachList[0].fileName">
                    <dt>첨부</dt>
                    <dd>
                        <div v-for="attach in recruitInfoDetail.attachList">
                            {{ attach.fileName }}
                            <KSATextButton v-if="attach.fileDir" class="ml-xs" text="다운로드" @click="$download(attach.fileDir)" />
                        </div>
                    </dd>
                </dl>
                <div v-if="recruitInfoDetail.prevBoard && recruitInfoDetail.prevBoard.boardId">이전글<RouterLink :to="{name:'CSRecruitInfoDetail', params:{id: recruitInfoDetail.prevBoard.boardId}}"><span>{{ recruitInfoDetail.prevBoard.title }}</span></RouterLink></div>
                <div v-if="recruitInfoDetail.nextBoard && recruitInfoDetail.nextBoard.boardId">다음글<RouterLink :to="{name:'CSRecruitInfoDetail', params:{id: recruitInfoDetail.nextBoard.boardId}}"><span>{{ recruitInfoDetail.nextBoard.title }}</span></RouterLink></div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .textarea-box {
        height: 300px;
    }
    small {
        @include font-size_xs;
        color: $gray_color;
    }
    .board-detail .body .text {
      overflow: hidden;
    }

</style>